module.exports = __webpack_public_path__ + "img/13.d288bf98.svg";